import React, { useId } from 'react';
import { toUtcClock } from './pushReminderPolicy';

const pad = (value) => String(value).padStart(2, '0');

/** Show the same UTC instant in the author's local time so the choice is easy to sanity-check. */
function localHint(clock) {
  const date = new Date();
  date.setUTCHours(clock.hours, clock.minutes, 0, 0);
  return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
}

/**
 * Controlled UTC clock editor. Legacy 12-hour values are displayed as the UTC
 * time they have always meant and are rewritten as UTC on the next change.
 */
export default function PushReminderTimeInput({ label, time, onChange, onRemove }) {
  const id = useId();
  const clock = toUtcClock(time);
  const value = clock ? `${pad(clock.hours)}:${pad(clock.minutes)}` : '';
  return (
    <div className="flex flex-wrap items-center gap-3 py-2">
      <label htmlFor={id} className="text-[13px] font-medium text-gray-700 dark:text-gray-200">{label} (UTC)</label>
      <input
        id={id}
        type="time"
        value={value}
        aria-describedby={`${id}-help`}
        className="input h-9 w-auto tabular-nums"
        onChange={(event) => {
          const [hours, minutes] = event.target.value.split(':');
          onChange('utcTime', { hours: hours ?? '', minutes: minutes ?? '', period: 'UTC' });
        }}
      />
      <span id={`${id}-help`} className="text-[13px] text-gray-500 dark:text-gray-400">
        {clock ? `${localHint(clock)} in your local time` : 'Choose a time.'}
      </span>
      <button
        type="button"
        onClick={onRemove}
        className="btn btn-danger-soft btn-sm"
        aria-label={`Remove ${label}`}
      >
        Remove
      </button>
    </div>
  );
}
